import './landing.css';
import materie from './ContentEdu.json';
import SelectedContentBox from '../dashboard/boxes/selectedContent';
import AppContext from '../../AppContext';
import { useContext} from 'react';

function EduLanding() {
    const appcontext = useContext(AppContext);
    const hasbundles2026=(appcontext && appcontext.features && (appcontext.features.bundle2026));
	return (<SelectedContentBox title={'Le materie'} customclass='educarousel' numitemsdesktop='7' numitemstoslide='7'>
		{materie.map((materia,index)=>(
			(materia.bundle2026 && (!hasbundles2026))?(<></>):(
                	<div key={index} style={{borderColor: materia.color}}>
				<>
					{materia.bundle2026?(<button className="chip"><span>Novità</span></button>):(<></>)}
                    		<div className="open-window-smallbox-ctr">
                    		    <a href={materia.url} target='_blank' className="open-window-smallbox" style={{borderColor:materia.color,backgroundColor:materia.color}} ></a>
                    		</div>
                	    <a href={materia.url} target='_blank'>
                	   	 <button><span style={{color:materia.color}}>{materia.name}</span></button>
                	    </a>
				</>
                	</div>)
		))}
	</SelectedContentBox>);
   /* return (
        <section className='content-landing' id='edu-landing-cards'>
            <h1>Le materie</h1>
            <div className="d-flex landing-cards">
		{materie.map((materia,index)=>(
                	<div key={index} style={{backgroundColor: materia.color}}>
                	    <a href={materia.url} target='_blank'>
                	   	 <button><span>{materia.name}</span></button>
                	    </a>
                	</div>
		))}
            </div>
        </section>
    )*/
}

export default EduLanding;
